import requests from "./httpService";

const CashVendorServices = {
  createCashVendor: async (body) => {
    return requests.post("/cash-vendors", body);
  },

  getCashVendors: async (status = "active", search = "") => {
    const params = new URLSearchParams();

    if (status) params.set("status", status);
    if (search.trim()) params.set("search", search.trim());

    const query = params.toString();

    return requests.get(
      `/cash-vendors${query ? `?${query}` : ""}`
    );
  },

  // Pass rows parsed from the CSV.
  importCashVendors: async (vendors) => {
    return requests.post("/cash-vendors/import", {
      vendors
    });
  }
};

export default CashVendorServices;